import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'alert',
  props: {
    duration: {
        type: Number,
        default() {
            return 5000
        }
    }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const visible = ref(true)
const progressWidth = ref(100)

let frame: number
let startTime: number

const updateProgress = () => {
    const elapsed = Date.now() - startTime
    const remaining = Math.max(0, props.duration - elapsed)
    progressWidth.value = (remaining / props.duration) * 100

    if (remaining <= 0) {
        dismiss()
    } else {
        frame = requestAnimationFrame(updateProgress)
    }
}

const dismiss = () => {
    visible.value = false
    cancelAnimationFrame(frame)
}

onMounted(() => {
    startTime = Date.now()
    frame = requestAnimationFrame(updateProgress)
})

onBeforeUnmount(() => {
    cancelAnimationFrame(frame)
})

const __returned__ = { props, visible, progressWidth, get frame() { return frame }, set frame(v) { frame = v }, get startTime() { return startTime }, set startTime(v) { startTime = v }, updateProgress, dismiss }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})